var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadsetIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 91.1429 91.1429",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "customer-support-1--customer-headset-help-microphone-phone-support"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 3826",
    d: "M19.5714 30.7143V27C19.5714 12.6406 31.212 1 45.5714 1C59.9309 1 71.5714 12.6406 71.5714 27V30.7143",
    stroke: "url(#paint0_linear_0_29)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3827",
    d: "M71.5714 60.4286V30.7143H82.7143C86.8171 30.7143 90.1429 34.0402 90.1429 38.1429V53C90.1429 57.1027 86.8171 60.4286 82.7143 60.4286H71.5714Z",
    stroke: "url(#paint1_linear_0_29)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3829",
    d: "M71.5714 60.4286V67.8571C71.5714 74.7798 66.8365 80.5971 60.4286 82.2463",
    stroke: "url(#paint2_linear_0_29)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3830",
    d: "M53 90.1429H38.1429C34.0402 90.1429 30.7143 86.8171 30.7143 82.7143C30.7143 78.6115 34.0402 75.2857 38.1429 75.2857H53C57.1027 75.2857 60.4286 78.6115 60.4286 82.7143C60.4286 86.8171 57.1027 90.1429 53 90.1429Z",
    stroke: "url(#paint3_linear_0_29)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3828",
    d: "M1 53V38.1429C1 34.0402 4.32592 30.7143 8.42857 30.7143H19.5714V60.4286H8.42857C4.32592 60.4286 1 57.1027 1 53Z",
    stroke: "url(#paint4_linear_0_29)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_29",
    x1: 70.9805,
    y1: 15.6136,
    x2: 0.788527,
    y2: 56.9587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_29",
    x1: 89.9318,
    y1: 45.3279,
    x2: 57.5966,
    y2: 52.1301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_29",
    x1: 71.4448,
    y1: 71.1586,
    x2: 51.7666,
    y2: 74.5414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_29",
    x1: 60.0909,
    y1: 82.5925,
    x2: 22.9128,
    y2: 107.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_29",
    x1: 19.3604,
    y1: 45.3279,
    x2: -12.9749,
    y2: 52.1301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadsetIllustration);
export default __webpack_public_path__ + "static/media/headset_illustration.14a08e30b1ccd3f83dbd551949125ce9.svg";
export { ForwardRef as ReactComponent };